import {combineReducers} from 'redux';
import auth from './auth';
import user from './user';
import report from './report';
import company from './company';
import staff from './staff';

export default combineReducers({ auth, user, report, company, staff })
